import { writable } from "svelte/store";

const AppAccessGranted = writable(false);
const UserToken = writable('');
const UserData = writable({});

export {
    AppAccessGranted,
    UserToken,
    UserData
}